// Dark Theme Color Palette
// These colors are used across the application including Material-UI theme and ReactFlow
// IMPORTANT: Keep these values in sync with defaultColors.scss

export const themeColors = {
  // Primary Colors
  primary: {
    main: "#90caf9", // Light blue for dark mode
  },
  secondary: {
    main: "#7d6e65", // Warm gray for left menu
  },
  // Background Colors
  background: {
    default: "#1a1a1a", // Very dark background
    paper: "#2a2a2a", // Slightly lighter for cards/panels
  },
  // Text Colors
  text: {
    primary: "#e0e0e0", // Light gray text
    secondary: "#b0b0b0", // Dimmer gray for secondary text
  },
} as const;
